<form class="form-group" [formGroup]="annuitantDetailForm" autocomplete="off" role="form" class="fieldHeight">
  <div *ngIf="contentData" class="float-left bg-white card-background">
    <app-content-top-nav [parentElement]="el" [parentFormToValidate]="annuitantDetailForm" [visibleBackNav]='true' [enableBackNav]='!editMode' (onBackClickHandler)="OnBackClick()"></app-content-top-nav>
    
    <div class="col-md-12 clear-all title-wrapper">
      <h1 class="title-text custom-header-h2" id="personalDetails-header">{{contentData.personalDetail.header}}</h1>
    </div>
    <div class="col-md-12 clear-all content-wrapper">
      <p class="content-top" id="personalDetails-introduction">
        {{contentData.personalDetail.introduction}}
      </p>
    </div>
    <div class="col-md-12 clear-all content-wrapper">
      <p class="font-weight-300 font-size subtitle clear-all" id="para_privacy-policy" aria-level="2" [innerHTML]="contentData.personalDetail.privacyPolicy">
       <!-- <strong id="privacy-policy" [innerHTML]="contentData.personalDetail.privacyPolicyLink"></strong> -->
        <!-- <strong>
          <a #anchorBlur (click)="blurHandler()" href={{contentData.personalDetail.privacyPolicyLink}} target="_blank" id="anchor_privacy-policy">{{contentData.personalDetail.privacyPolicyText}}</a></strong>
          -->
      </p>
    </div>
    <div *ngIf="disabledUkIndicator" class="col-md-12 mar-tlr-40 bg-lightblue">
        <p class="inner-content-data pad-lr-0" id="defined-benefit">{{contentData.personalDetail.disabledInfoNotification}}</p>
    </div>
    <ng-container *ngIf="!disabledUkIndicator">
    <!--Personal detail page-->
    <div class="col-md-12 wrapperMargin content-wrapper ">
      
      <!--start comment-->
      <div *ngIf="false" class="col-md-12 clear-all margin-top-30">
            <div class="col-md-6 clear-all">
             <label for="forename" class="form-label" id="first-name">
                  {{contentData.personalDetail.firstName}}
          </label>
              <input class="form-control"
              id="forename" name="forename"
              formControlName="forename" type="text" 
              
              >
            </div>
      </div>
      <div *ngIf="false" class="col-md-12 clear-all margin-top-30">
          <div class="col-md-6 clear-all">
              <label for="contactNumber" class="form-label" id="contact">
                  {{contentData.personalDetail.contactNumber}}
              </label>
                  <input class="form-control"
                  id="contactNumber" name="contactNumber"
                  formControlName="contactNumber" type="text" 
                  
                  >
          </div>
      </div>

      <div *ngIf="false" class="col-md-12 clear-all margin-top-30">
          <div class="col-md-6 clear-all">
              <label for="surname"  class="form-label" id="surname">
                  {{contentData.personalDetail.surname}}
              </label>
                  <input class="form-control"
                  id="surname" name="surname"
                  formControlName="surname" type="text" 
                  
                  >
          </div>
      </div>
      <div *ngIf="false" class="col-md-12 clear-all margin-top-30">
          <div class="col-md-6 clear-all">
              <label for="emailAddress"  class="form-label" id="email">
                  {{contentData.personalDetail.emailAddress}}
              </label>
                  <input class="form-control"
                  id="emailAddress" name="emailAddress"
                  formControlName="emailAddress" type="text" 
                  
                  >
          </div>
      </div>

      <!--end comment-->

    <div class="col-md-12 clear-all ">
        <div class="col-md-12 clear-all">
          <div class="col-md-7 clear-all">
            <app-date-input [minAge]="personalMinAge"  (onBlurHandler)="checkDataChange($event)" [pageName]="'annuitant'" [parent]="annuitantDetailForm" [controllerData]="dobCodeConfig" 
            formControlName="dateOfBirth" [tooltipData]="dobInformationConfig" 
           >
          </app-date-input>
          </div>
          
          <div class="col-md-2 margin-top-2 dobInformation">
            <app-tool-tip-notification (dobInfoEmitter)="dobInfoReceiver($event)" [childId]="'dobInformationConfig'" [tooltipData]="dobInformationConfig"></app-tool-tip-notification>
          </div>
        </div>
        <div class="col-md-6 clear-all">

        </div>
      </div>
      <app-modal *ngIf="displayAlert" [modalConfig]="alertModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
      (secondaryBtnClick)="alertSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>
      
      <ng-container *ngIf="showModalForCardRefresh">
        <app-modal [modalConfig]="alertCardRefreshModalConfig" (closeModal)="closeCardRefreshModal()" (primaryBtnClick)="alertPrimaryBtnClickinModal()"
        (secondaryBtnClick)="alertSecondaryCardRefreshBtnClick()" [saveDataFlag]="false"></app-modal>
      </ng-container>

      

      <app-modal *ngIf="ageValidatorFlag" [modalConfig]="ageAlertModalConfig" (closeModal)="closeAgeModal()" (primaryBtnClick)="alertAgePrimaryBtnClick()"
      (secondaryBtnClick)="alertAgeSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>

      <div class="col-md-12 clear-all margin-top-30">
        <div class="col-md-6 clear-all">
          <app-dropdown [pageName]="'annuitant'" (onChangeHandler)="ddlChange($event)" [dropdownConfig]="genderConfig" [controlName]="'gender'" [parent]="annuitantDetailForm">
          </app-dropdown>
        </div>


      </div>
      <div class="col-md-12 clear-all margin-top-30">
        <div class="col-md-6 clear-all">
          <app-dropdown [pageName]="'annuitant'" (onChangeHandler)="ddlChange($event)" [dropdownConfig]="maritalStatusConfig" [controlName]="'maritalStatus'" [parent]="annuitantDetailForm">
          </app-dropdown>
        </div>


      </div>
      <div class="col-md-12 clear-all ">
        <div class="ukIndicatorText" aria-describedby="ukIndicatorText">
          <!-- <span class="form-label" id="ukIndicatorText" for="ukaddressIndicator" style="margin-top: 32px">{{contentData.personalDetail.ukaddressIndicator}}</span> -->
          <div class="mt-10">
          <app-question [questiontextRequired]="true" [childId]="'ukaddressIndicator'" [questionConfig]="userInputDetail.radioButtonIsUKAddressConfig" [parent]="annuitantDetailForm"
            [controlName]="'ukaddressIndicator'" (toggleChange)="toggleContainer($event)" [id]="'question_ukaddressIndicator'">
          </app-question>
            <!-- <app-radio-button [disableControl]="disabledUkIndicator" (toggleContainer)="toggleContainer($event)" [configValue]="radioButtonIsUKAddressConfig">
            </app-radio-button> -->
          </div>
        </div>
        <!-- <div class="col-md-8 postcodeInformation">
          <app-tool-tip-notification [childId]="'postCodeInformationConfig'" [tooltipData]="postCodeInformationConfig"></app-tool-tip-notification>
        </div> -->
      </div>

      <div class="col-md-12 clear-all margin-top-30" 
      *ngIf="(annuitantDetailForm.get('ukaddressIndicator').value==='Y')">
        <div class="col-md-6 clear-all">
          <app-postcode [postCodeConfig]="postCodeConfig" (onChangeHandler)="txtChange($event)"  [controlName]="'postcode'" [parent]="annuitantDetailForm" 
          [required]="annuitantDetailForm.get('ukaddressIndicator').value==='Y'?true:false "
            formControlName="postcode" [pageName]="'annuitant'" >
            ></app-postcode>
        </div>
        <div class="col-md-6 postcodeInformationtext">
          <app-tool-tip-notification [childId]="'postCodeTextConfig'" [tooltipData]="postCodetextConfig"></app-tool-tip-notification>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="disabledUkIndicator">
    <div class="col-md-12 content-wrapper margin-top-30">
        <p class="question-font" id="dateofbirth">Date of birth</p>
    </div>
    <div class="col-md-12 margin-left-30">
          <div class="col-md-2 clear-all">
            <p class="text-color values-font" id="dateofbirth">{{getData(1)}}</p>
          </div>
          <div class="col-md-10 clear-all info-tool-tip-2">
              <app-tool-tip-notification [childId]="'dobInformationConfig'" [tooltipData]="dobInformationConfig"></app-tool-tip-notification>
          </div>
    </div>
    <div class="col-md-12 content-wrapper margin-top-30">
        <p class="question-font">{{genderConfig.label}}</p>
    </div>
    <div class="col-md-12 margin-left-30">
      <p class="text-color values-font" id="genderReadOnly">{{getData(2)}}</p>
    </div>
    <div class="col-md-12 content-wrapper margin-top-30">
      <p class="question-font">{{maritalStatusConfig.label}}</p>
    </div>
    <div class="col-md-12 margin-left-30">
        <p class="text-color values-font" id="maritalStatusReadOnly">{{getData(3)}}</p>
    </div>
    <div class="col-md-12 content-wrapper margin-top-30">
        <p class="question-font">Are you a UK resident?</p>
    </div>
    <div class="col-md-12 margin-left-30">
          <div class="col-md-2 clear-all">
            <p class="text-color values-font" id="ukIndicatorReadOnly">{{getData(4)}}</p>
          </div>
          <div class="col-md-10 clear-all info-tool-tip-3">
              <app-tool-tip-notification [childId]="'ukAddressConfig'" [tooltipData]="userInputDetail.radioButtonIsUKAddressConfig.infoIconData"></app-tool-tip-notification>
          </div>
    </div>
  <ng-container *ngIf="(annuitantDetailForm.get('ukaddressIndicator').value==='Y')">
    <div class="col-md-12 content-wrapper margin-top-30">
      <p class="question-font">{{postCodeConfig.labelText}}</p>
    </div>
    <div class="col-md-12 margin-left-30">
      <div class="col-md-2 clear-all">
        <p class="text-color values-font" id="postCodeReadOnly">{{getData(5)}}</p>
      </div>
      <div class="col-md-10 clear-all info-tool-tip-4">
          <app-tool-tip-notification [childId]="'postCodeTextConfig'" [tooltipData]="postCodetextConfig"></app-tool-tip-notification>
      </div>
    </div>
  </ng-container>
  </ng-container>
    <div class="col-md-12 underline margin-top">
    </div>
    <!-- <app-modal *ngIf="displayAlert" [modalConfig]="alertModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
      (secondaryBtnClick)="alertSecondaryBtnClick()"></app-modal>

      <app-modal *ngIf="ageValidatorFlag" [modalConfig]="ageAlertModalConfig" (closeModal)="closeAgeModal()" (primaryBtnClick)="alertAgePrimaryBtnClick()"
      (secondaryBtnClick)="alertAgeSecondaryBtnClick()"></app-modal> -->
	  
    <!--ENDPersonal detail page-->
    <div class="col-md-12 clear-all">
      <div class="float-left"> 
        <app-save [parentElement]="el" [parentFormToValidate]="annuitantDetailForm" [location]="'contentBottom'"></app-save>
      </div> 
      <div class="float-right">
          <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'"></app-content-bottom-nav>
        <!-- <app-content-bottom-nav [userInputDetail]="userInputDetail" (click)="gotoPensionDetails()" [buttonType]="'normalCTA'"></app-content-bottom-nav> -->
      </div>
    </div>
  </div>
</form>
